// ** React Imports
import { useEffect } from 'react'
import { NavLink } from 'react-router-dom'

// ** Third Party Components
import { IconCircle, IconCircleDot } from '@tabler/icons-react'
import { staticAssetsPath } from '../../../../../configs/constants'
import { useSasToken } from '../../../../../_hooks/useSasToken'
import { IconLayoutSidebarLeftCollapse, IconX } from '@tabler/icons-react'

const VerticalMenuHeader = (props) => {
  // ** Props
  const { menuCollapsed, setMenuCollapsed, setMenuVisibility, setGroupOpen, menuHover } = props
  const { appendToken } = useSasToken()
  const showIcon = menuCollapsed && !menuHover

  // ** Reset open group
  useEffect(() => {
    if (!menuHover && menuCollapsed) setGroupOpen([])
  }, [menuHover, menuCollapsed])

  // ** Menu toggler component
  const Toggler = () => {
    if (!menuCollapsed) {
      return (
        <IconCircleDot
          size={20}
          data-tour="toggle-icon"
          className="text-primary toggle-icon d-none d-xl-block"
          onClick={() => setMenuCollapsed(true)}
        />
      )
    } else {
      return (
        <IconCircle
          size={20}
          data-tour="toggle-icon"
          className="text-primary toggle-icon d-none d-xl-block"
          onClick={() => setMenuCollapsed(false)}
        />
      )
    }
  }

  const getLogo = () => {
    if (
      localStorage.getItem('skin') === null ||
      JSON.parse(localStorage.getItem('skin')) === 'light'
    ) {
      return showIcon
        ? appendToken(`${staticAssetsPath}/images/logo/Centrali-Icon.svg`)
        : appendToken(`${staticAssetsPath}/images/logo/Centrali-Portal.svg`)
    } else if (JSON.parse(localStorage.getItem('skin')) === 'dark') {
      return showIcon
        ? appendToken(`${staticAssetsPath}/images/logo/Centrali-Icon-dark.svg`)
        : appendToken(`${staticAssetsPath}/images/logo/Centrali-Portal-dark.svg`)
    } else return appendToken(`${staticAssetsPath}/images/logo/Centrali-Portal.svg`)
  }

  return (
    <div className="navbar-header">
      <ul className="nav navbar-nav flex-row">
        <li className="nav-item me-auto">
          <NavLink to={'/app-store'} className="navbar-brand">
            <span className={showIcon ? 'brand-icon' : 'brand-logo'}>
              <img src={getLogo()} alt="logo" />
            </span>
          </NavLink>
        </li>
        <li className="nav-item nav-toggle">
          <div className="nav-link modern-nav-toggle cursor-pointer">
            <Toggler />
            <IconX
              onClick={() => setMenuVisibility(false)}
              className="toggle-icon icon-x d-block d-xl-none"
              size={20}
            />
          </div>
        </li>
      </ul>
    </div>
  )
}

export default VerticalMenuHeader
